import React from 'react';

import { HeroComponentFragment } from '../../../../graphql.schema';
import HeroComponent from '../../HeroComponent/HeroComponent';

export const StrapiHeroComponent: React.FC<HeroComponentFragment> = (props) => {
  return (
    <div className="hero-component-wrapper">
      <HeroComponent {...props} />
    </div>
  );
};
